import React from "react";
import { Card, Col } from "antd";
import { CompassOutlined, CarOutlined } from "@ant-design/icons";
import { theme } from "../constants/theme";

const StatisticsCards = ({
  totalVehicles,
  pichinchaTotal,
  guayasTotal,
  globalStats,
  getProvincePercentage,
}) => {
  const formatNumber = (number) => {
    if (!number && number !== 0) return "0";
    return number.toString();
  };

  const cardStyle = {
    ...theme.cards.base,
    padding: "16px",
    height: "100%",
    minHeight: "140px",
  };

  const provinceCardContent = (
    province,
    total,
    color,
    avgDayDistance,
    avgNightDistance
  ) => (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
      }}
    >
      <CarOutlined
        style={{ fontSize: "24px", color: color, marginBottom: "8px" }}
      />
      <div
        style={{
          color: theme.text.secondary,
          fontSize: "14px",
          marginBottom: "4px",
        }}
      >
        {province}
      </div>
      <div style={{ marginBottom: "4px" }}>
        <span
          style={{
            fontSize: "24px",
            color: color,
            fontWeight: "500",
            marginRight: "8px",
          }}
        >
          {formatNumber(total)}
        </span>
        <span
          style={{
            color: theme.text.light,
            fontSize: "20px",
            fontWeight: "500",
          }}
        >
          {getProvincePercentage(province)}%
        </span>
      </div>
      <div
        style={{
          display: "flex",
          fontSize: "16px",
          color: theme.text.secondary,
          gap: "16px",
          justifyContent: "center",
        }}
      >
        <div>
          <span style={{ color: theme.text.light }}>Diurno: </span>
          <span style={{ color: color, fontWeight: "500" }}>
            {avgDayDistance?.toFixed(2)}KM
          </span>
        </div>
        <div>
          <span style={{ color: theme.text.light }}>Nocturno: </span>
          <span style={{ color: color, fontWeight: "500" }}>
            {avgNightDistance?.toFixed(2)}KM
          </span>
        </div>
      </div>
    </div>
  );

  return (
    <>
      <Col xs={24} md={8}>
        <Card style={cardStyle}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign: "center",
            }}
          >
            <CompassOutlined
              style={{
                fontSize: "24px",
                color: theme.colors.primary,
                marginBottom: "8px",
              }}
            />
            <div
              style={{
                color: theme.text.secondary,
                fontSize: "14px",
                marginBottom: "4px",
              }}
            >
              Total Vehículos
            </div>
            <div
              style={{
                fontSize: "24px",
                color: theme.colors.primary,
                fontWeight: "500",
              }}
            >
              {formatNumber(totalVehicles)}
            </div>
          </div>
        </Card>
      </Col>

      <Col xs={24} md={8}>
        <Card style={cardStyle}>
          {provinceCardContent(
            "Pichincha",
            pichinchaTotal,
            theme.colors.secondary,
            globalStats.Pichincha?.avgDayDistance,
            globalStats.Pichincha?.avgNightDistance
          )}
        </Card>
      </Col>

      <Col xs={24} md={8}>
        <Card style={cardStyle}>
          {provinceCardContent(
            "Guayas",
            guayasTotal,
            theme.colors.tertiary,
            globalStats.Guayas?.avgDayDistance,
            globalStats.Guayas?.avgNightDistance
          )}
        </Card>
      </Col>
    </>
  );
};

export default StatisticsCards;
